import { createContext, useContext, useState } from 'react';

export interface SurveyFormData {
  qualifications: string[];
  workStyle: string;        // 単一選択（DB: work_style）
  timing: string;           // DB: transfer_timing
  nearestStation: string;   // DB: postal_code（GAS側で最寄り駅列に集約）
  lastName: string;         // DB: name（姓＋名を結合して送信）
  firstName: string;        // DB: name（姓＋名を結合して送信）
  birthYear: string;        // DB: birth_year
  birthMonth: string;       // DB: birth_month
  birthDay: string;         // DB: birth_day
  email: string;            // フォーム内部用（DBには送信しない）
  phone: string;            // DB: phone（送信前にハイフン除去）
}

const initialFormData: SurveyFormData = {
  qualifications: [],
  workStyle: '',
  timing: '',
  nearestStation: '',
  lastName: '',
  firstName: '',
  birthYear: '',
  birthMonth: '',
  birthDay: '',
  email: '',
  phone: '',
};

interface SurveyContextType {
  isCompleted: boolean;
  setIsCompleted: (value: boolean) => void;
  step: number;
  setStep: (step: number) => void;
  formData: SurveyFormData;
  onChange: (field: keyof SurveyFormData, value: string | string[]) => void;
  submitting: boolean;
  setSubmitting: (value: boolean) => void;
}

const SurveyContext = createContext<SurveyContextType>({
  isCompleted: false,
  setIsCompleted: () => {},
  step: 1,
  setStep: () => {},
  formData: initialFormData,
  onChange: () => {},
  submitting: false,
  setSubmitting: () => {},
});

export function SurveyProvider({ children }: { children: React.ReactNode }) {
  const [isCompleted, setIsCompleted] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState<SurveyFormData>(initialFormData);
  const [submitting, setSubmitting] = useState(false);

  const onChange = (field: keyof SurveyFormData, value: string | string[]) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <SurveyContext.Provider
      value={{ isCompleted, setIsCompleted, step, setStep, formData, onChange, submitting, setSubmitting }}
    >
      {children}
    </SurveyContext.Provider>
  );
}

export function useSurvey() {
  return useContext(SurveyContext);
}
